var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemicircleDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 295,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "semicircle-dots_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 295,
    height: 295
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00F"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 36.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 42.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 48.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 54.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 60.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 66.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 72.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 78.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 84.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 90.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 96.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 102.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 108.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 114.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 120.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 126.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 132.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 138.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 144.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 150.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 156.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 162.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 168.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 174.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 180.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 186.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 192.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 198.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 204.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 210.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 216.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 222.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 228.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 234.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 240.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 246.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 252.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 258.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 264.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 270.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 276.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 282.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 288.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 294.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 294.5,
    r: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#semicircle-dots_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 147.5,
    r: 147.5,
    fill: "#00F"
  }))));
}
export default SvgSemicircleDots;